<ng-container #fieldComponent></ng-container>
<div *ngIf="showError">
  <formly-validation-message
    class="p-error"
    [field]="field"
  ></formly-validation-message>
</div>
